import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SendIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 19V5M6 11L12 5L18 11"
        stroke={finalColor}
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default SendIcon;
